module.exports = " <div class=button_box _v-833b134a=\"\"> <input type=\"{{ inputType }}\" value=\"{{ inputValue }}\" _v-833b134a=\"\"> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-833b134a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/input-bundle/ButtonBox.vue
 ** module id = 360
 ** module chunks = 2
 **/